import dayjs from "dayjs";

export function dateFilter(timestamp, format = 'YYYY-MM-DD hh:mm:ss') {
    return dayjs(timestamp).format(format)
}
